export default theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    height: '100%'
  },
  header: {
    height: '4rem',
    backgroundColor: theme.palette.secondary.main
  },
  fieldsGroup: {
    padding: theme.spacing(2)
  },
  headerTitle: {
    marginTop: '1rem',
    marginBottom: '1rem',
    marginLeft: 26,
    color: theme.palette.primary.main
  },
  closeButton: {
    float: 'right',
    color: theme.palette.primary.main
  },
  cancelButton: {
    display: 'flex',
    alignItems: 'flex-end',
    flexGrow: 1,
    padding: theme.spacing(2)
  },
  mTop: {
    marginTop: '1rem'
  },
  applicationFieldset: {
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: 4,
    padding: 20,
    width: 'calc(100% - 40px)',
    '&:hover': {
      borderColor: '#000'
    }
  }
});
